import { Signal } from "@angular/core";
import { ICountryMask } from "./country-masks.model"

export interface ICountryRules {
  masksSignal: Signal<ICountryMask | null>
  active: Signal<boolean>
  loadMasks(country: string): Promise<void>
}
